/**
 * Updates the URL parameters by adding or overwriting the provided object,
 * while keeping existing parameters not part of the object.
 *

 */
function updateUrlParams(params) {
  if (typeof params !== 'object' || params === null) {
    throw new Error('Params must be a valid object');
  }

  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);

  Object.keys(params).forEach(key => {
    if (key === 'filters' || key === 'sorting') {
      searchParams.set(key, JSON.stringify(params[key]));
    } else {
      searchParams.set(key, params[key]);
    }
  });

  // Update the URL without reloading the page
  url.search = searchParams.toString();
  return url.toString();
}

export default updateUrlParams;
